import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import colours from 'theme/atoms/colours';

interface ContainerProps {
  $showOnDesktop?: boolean;
  $hasCenterSlot?: boolean;
}

export const Container = styled('div')<ContainerProps>`
  align-items: center;
  background: linear-gradient(
    180deg,
    ${colours.neutral[100]} 44.74%,
    rgba(246, 247, 247, 0.9) 77.95%,
    rgba(246, 247, 247, 0) 100%
  );
  box-sizing: border-box;
  display: flex;
  flex-shrink: 0;
  height: ${(props) => (props.$hasCenterSlot ? 'auto' : '80px')};
  min-height: 80px;
  justify-content: space-between;
  left: 0;
  padding: 20px 15px 15px 15px;
  pointer-events: none;
  position: ${(props) => (props.$hasCenterSlot ? 'relative' : 'fixed')};
  top: 0;
  width: 100%;
  z-index: 100;
  margin-top: 0;

  svg {
    stroke-width: 2;
  }

  @media (min-width: ${breakpoints.laptopMin}) {
    display: ${(props) => (props.$showOnDesktop ? 'flex' : 'none')};
    position: ${(props) => (props.$showOnDesktop ? 'sticky' : 'fixed')};
    left: ${(props) => (props.$showOnDesktop ? 'auto' : '0')};
    top: 0;
    width: 100%;
    max-width: 100%;
    margin: 0;
    align-self: ${(props) => (props.$showOnDesktop ? 'flex-start' : 'auto')};
    pointer-events: ${(props) => (props.$showOnDesktop ? 'auto' : 'none')};
  }
`;

export const ActionsRow = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: auto;
`;

export const CenterSlot = styled('div')`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  max-width: 590px;
  width: calc(100% - 200px);
`;
